export default {"src":"/_next/static/media/compliance-mapping.9ca68b02.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};